import * as THREE from '@phdsoft/three';
import { WorkableElement } from '../WorkableElement';
import { ConnectionWithSnCurve } from 'src/app/fea/models/connection.model';

export class StructuralConnection extends WorkableElement {
  public connectionData: ConnectionWithSnCurve;

  constructor(mesh: THREE.Mesh, id: string, connectionData: ConnectionWithSnCurve) {
    // Pass the mesh, a default material, and ID to parent
    super(mesh, mesh.material as THREE.Material, id);

    this.Guid = id;
    this.connectionData = connectionData;
    this.elementTypeName = 'StructuralConnection';

    // Store reference to self in the mesh for easy retrieval during raycasting
    mesh.userData['element'] = this;
    mesh.name = id; // Critical: Raycaster looks for this name
  }

  // Required implementation from abstract class
  public VerifyProperties() { return true; }
}
